import React from "react"
import { useDispatch } from "react-redux"
import { useParams } from "react-router-dom"
import CustomButton from "components/Atoms/CustomButton"
import BackButton from "components/Templates/BackButton"
import ModuleHeader, { Description } from "components/Templates/ModuleHeader"
import { useSearchFilter } from "hooks/searchFilterHooks"
import {
  OPEN_DISPATCH_DRAWER,
  RESET_STATE,
  TOGGLE_DISPATCH_SUMMARY,
} from "store/dispatch.redux"
import DispatchFilter from "./DispatchFilter"
import SummaryOrdersDrawer from "./drawer/SummaryOrdersDrawer"

const DispatchHeader = () => {
  const dispatch = useDispatch()
  const [{ search }, setFilter] = useSearchFilter()
  const { id } = useParams()
  const tripId = parseInt(id)
  return (
    <ModuleHeader
      query={search}
      onQueryChange={search => {
        setFilter(prev => ({
          ...prev,
          search,
        }))
        if (!tripId)
          dispatch({
            type: RESET_STATE,
          })
      }}
      className="vt-dispatch-header"
      header={
        <>
          <BackButton className="mr-2" />
          <Description icon="th-list" title="Confirmed Orders" />
        </>
      }
    >
      <SummaryOrdersDrawer className="mr-3" />
      <DispatchFilter />

      <CustomButton
        className="mr-3"
        icon="clipboard"
        text="Summary"
        onClick={e => {
          dispatch({
            type: TOGGLE_DISPATCH_SUMMARY,
          })
        }}
      />
      <CustomButton
        dark
        icon="edit"
        text="Dispatches"
        onClick={e => {
          dispatch({
            type: OPEN_DISPATCH_DRAWER,
          })
        }}
      />
    </ModuleHeader>
  )
}
export default DispatchHeader
